module.exports = __webpack_public_path__ + "static/media/piper-sad.622bac10.svg";